/**
 * Die Prüfungen der Hausverwaltung — eine Zeile je Objekt und Jahr.
 */

import { useEffect, useState } from 'react';

import { api, datum } from '../../lib/api';
import type { PruefungKurz } from '../../lib/typen';
import { Fortschritt } from '../../komponenten/Fortschritt';

export function Pruefungsliste({ onOeffnen, onNeu, onMeldung }: { onOeffnen: (id: string) => void; onNeu: () => void; onMeldung: (t: string) => void }) {
  const [liste, setListe] = useState<PruefungKurz[] | null>(null);

  useEffect(() => {
    api.mandant
      .pruefungen()
      .then(setListe)
      .catch((g) => {
        setListe([]);
        onMeldung((g as Error).message);
      });
  }, [onMeldung]);

  if (liste === null) return <div className="wrap"><div className="skelett" style={{ height: 160 }} /></div>;

  return (
    <div className="wrap">
      <div className="seitenkopf">
        <div>
          <h2 style={{ margin: 0 }}>Prüfungen</h2>
          <p className="s" style={{ margin: '4px 0 0' }}>Je Objekt und Abrechnungsjahr eine Prüfung. Der Beirat sieht nur seine.</p>
        </div>
        <div className="spacer" />
        <button className="btn primary" onClick={onNeu}>
          Neue Prüfung
        </button>
      </div>

      {liste.length === 0 ? (
        <div className="leer card">
          <h3>Noch keine Prüfung</h3>
          <p>Legen Sie die erste an: Objekt und Jahr wählen, Belege werden geholt, dann Unterlagen hochladen und den Beirat einladen.</p>
          <button className="btn primary" onClick={onNeu}>
            Erste Prüfung anlegen
          </button>
        </div>
      ) : (
        <div className="tblwrap">
          <table className="pruefungen">
            <thead>
              <tr>
                <th>Objekt</th>
                <th>Jahr</th>
                <th>Status</th>
                <th>Fortschritt</th>
                <th>Belege</th>
                <th>Unterlagen</th>
                <th>Beiräte</th>
                <th>Rückfragen</th>
              </tr>
            </thead>
            <tbody>
              {liste.map((p) => (
                <tr key={p.id} className="klickbar" onClick={() => onOeffnen(p.id)}>
                  <td>
                    <b>{p.liegenschaftBezeichnung}</b>
                    <div className="s" style={{ margin: 0 }}>
                      {p.belegquelle === 'idwell' ? 'iDWELL' : 'Importpaket'} · angelegt {datum(p.erstelltAm)}
                    </div>
                  </td>
                  <td>{p.periodeVon.slice(0, 4)}</td>
                  <td>
                    <span className={`pill ${p.status === 'abgeschlossen' ? 'ok' : p.status === 'freigegeben' ? 'n' : 'w'}`}>
                      <span className="dot" />
                      {p.status === 'abgeschlossen' ? 'Abgeschlossen' : p.status === 'freigegeben' ? 'Freigegeben' : 'In Vorbereitung'}
                    </span>
                  </td>
                  <td style={{ minWidth: 160 }}>
                    <Fortschritt anteil={p.fortschritt} text={`${p.schritteErledigt}/5`} />
                  </td>
                  <td className="num">{p.belege}</td>
                  <td className="num">{p.dokumente}</td>
                  <td className="num">{p.beiraete}</td>
                  <td className="num">{p.offeneRueckfragen > 0 ? <span className="badge w">{p.offeneRueckfragen}</span> : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
